export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768
}

export const isTabletDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  return /tablet|ipad|playbook|silk/i.test(userAgent) || (/android/i.test(userAgent) && !/mobile/i.test(userAgent))
}

export const isDesktopDevice = () => {
  return !isMobileDevice() && !isTabletDevice()
}
